// Deep link into the merchant's Shopify theme editor with the Releva.ai app
// embed pre-selected, so enabling it is one toggle plus Save. Built in three
// places (the activation wizard step, the dashboard alert and the Shopify
// integration guide), hence one definition here.
export const themeEditorAppEmbedUrl = (domain) =>
  `${domain.url}/admin/themes/current/editor?context=apps&template=index&activateAppId=${
    import.meta.env.VITE_SHOPIFY_APP_ID
  }/releva-ai`;
